/**
 * @owner @Appboy/email
 */

// generated from 1_408_941 samples

import { z } from "zod";
import { common } from "../common";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import { emailLinkPostSchema } from "./emailLinkPostSchema";
import { listUnsubscribeScopeSchema } from "../shared/listUnsubscribeScopeSchema";

export const emailMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("email"),
  // undefined: 1_285_593 (91.25%), defined 123_348 (8.75%)
  // null: 123_279 (99.94%)
  // format object-id: 37 (53.62%)
  accessibility_test_id: z.string().nullable().optional(),
  // undefined: 1_285_593 (91.25%), defined 123_348 (8.75%)
  // null: 123_279 (99.94%)
  // avg: 937926184.97, min: 0, max: 1749506337
  accessibility_test_start_time: z.int().min(0).nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  amp_content_block_inclusion_sequence: z.int().min(0).optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  amp_link_includer_sequence: z.int().min(0).optional(),
  // undefined: 210_635 (14.95%), defined 1_198_306 (85.05%)
  // null: 1_112_572 (92.85%)
  bcc_address: z.string().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // null: 684_240 (57.06%)
  dnd_template_json: z.string().nullable().optional(),
  // undefined: 1_408_271 (99.95%), defined 670 (0.05%)
  draft_link_alias_includer_state: z.string().nullable().optional(),
  // undefined: 1_407_688 (99.91%), defined 1_253 (0.09%)
  draft_link_management_data: z.string().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // null: 1_198_286 (99.92%)
  email_amp_body: z.string().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // null: 13_390 (1.12%)
  email_body: z.string().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 1_194_367 (99.59%)
  email_extras: z.record(z.string(), z.string()).nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 1_165_058 (97.14%)
  email_headers: z.record(z.string(), z.string()).nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 12_452 (1.04%)
  email_subject: z.string().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 1_186_533 (98.93%)
  email_test_id: z.string().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 1_186_533 (98.93%)
  // avg: 925521326.01, min: 0, max: 1749527717
  email_test_start_time: z.int().min(0).nullable().optional(),
  // undefined: 323_616 (22.97%), defined 1_085_325 (77.03%)
  esp: common.numericEnum([0, 3, 4]).optional(),
  // undefined: 209_932 (14.90%), defined 1_199_009 (85.10%)
  // null: 111_986 (9.34%)
  from_address: z.string().nullable().optional(),
  // undefined: 346_533 (24.60%), defined 1_062_408 (75.40%)
  // null: 1_012_725 (95.32%)
  from_address_dynamic_domain: z.string().nullable().optional(),
  // undefined: 209_932 (14.90%), defined 1_199_009 (85.10%)
  // null: 111_986 (9.34%)
  from_display_name: z.string().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // true 171_809 (14.33%), false 1_027_519 (85.67%)
  has_been_sent_to_seed_groups: z.boolean().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // true 929 (0.08%), false 1_198_399 (99.92%)
  has_included_amp: z.boolean().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // avg: 4.62, min: 0, max: 6218
  html_content_block_inclusion_sequence: z.int().min(0).optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // avg: 119.59, min: 0, max: 50520
  html_link_includer_sequence: z.int().min(0).optional(),
  // undefined: 323_616 (22.97%), defined 1_085_325 (77.03%)
  // null: 6_626 (0.61%)
  ip_pool_name: z.string().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // true 514_955 (42.94%), false 684_294 (57.06%)
  is_dnd_template: z.boolean().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // true 1_198_539 (99.94%), false 710 (0.06%)
  is_test_send_allowed_in_sandbox_account: z.boolean().optional(),
  // avg: 393469906.19, min: 0, max: 1749564311
  last_sent_email: z.int().min(0).nullable().optional(),
  // The server never returns `links` or `tracked_link_count` in GET responses.
  // They are present here so GET-shaped message state can preserve link data written
  // by the email composer through the GET→POST round-trip at save time. Without these
  // fields the converters would drop link data, causing silent data loss when the HTML
  // body differs even slightly from the persisted version.
  links: z.array(emailLinkPostSchema).nullable().optional(),
  tracked_link_count: z.int().min(0).nullable().optional(),
  // Never returned by the server either. The composer's upsert_lid response assigns each new content block
  // inclusion an id (`{{content_blocks.${name} | id: 'cb1'}}`) and reports it in this {inclusion id => content
  // block name} mapping. The store keeps it beside `links` so the save POST sends it back; without it the server
  // treats the inclusion as new and assigns the next id.
  draft_content_block_mapping: z.record(z.string(), z.string()).nullable().optional(),
  list_unsubscribe_header_config: z
    .object({
      // undefined: 1_184_892 (98.80%), defined 14_436 (1.20%)
      custom_mail_to: z.string().nullable().optional(),
      // undefined: 1_184_892 (98.80%), defined 14_436 (1.20%)
      custom_url: z.string().nullable().optional(),
      scope: listUnsubscribeScopeSchema.nullable().optional(),
      // undefined: 1_173_406 (97.84%), defined 25_922 (2.16%)
      subscription_group_ids: z.array(common.objectId).nullable().optional(),
    })
    .nullable()
    .optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // null: 979_579 (81.68%)
  plaintext_body: z.string().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // null: 141_108 (11.77%)
  preheader: z.string().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 493_996 (41.19%)
  reply_to_address: z.string().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 130_496 (10.88%)
  seed_group_ids: z.array(common.objectId).nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // true 451_006 (37.61%), false 748_243 (62.39%)
  should_inline_css: z.boolean().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 133_646 (11.14%)
  // true 85_213 (8.00%), false 980_469 (92.00%)
  should_send_to_seed_groups: z.boolean().nullable().optional(),
  // undefined: 209_692 (14.88%), defined 1_199_249 (85.12%)
  // true 376_135 (31.36%), false 823_114 (68.64%)
  should_whitespace_preheader: z.boolean().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 1_187_020 (98.97%)
  spam_test_id: z.string().nullable().optional(),
  // undefined: 209_613 (14.88%), defined 1_199_328 (85.12%)
  // null: 1_187_020 (98.97%)
  // avg: 521128769.42, min: 0, max: 1749527722
  spam_test_start_time: z.int().min(0).nullable().optional(),
  email_attachments: z
    .array(
      z.object({
        url: z.string().nullable().optional(),
        file_name: z.string().nullable().optional(),
        media_library_asset_id: z.string().nullable().optional(),
        media_type: z.string().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
});
